import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploaderService } from './services/uploader.service';
import { DetailPanelService } from './services/detail-panel.service';
import { NgMediaComponent } from './components/ng-media/ng-media.component';
import { UploadComponent } from './components/upload/upload.component';
import { MediaToolbarComponent } from './components/media-toolbar/media-toolbar.component';
import { GridViewComponent } from './components/grid-view/grid-view.component';
import { MediaDetailsComponent } from './components/media-details/media-details.component';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from './spinner/spinner.component';
import { UtilsService } from './services/utils.service';
import { RequestsService } from './services/requests.service';
import { StoreService } from './services/store.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgMediaFileExplorerComponent } from './components/file-explorer/file-explorer.component';
import { NgdTranslatePipe } from './ngd-translate.pipe';
import { NgMediaConfigService } from './services/ng-media-config.service';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgMediaCropperComponent } from './components/ng-media-cropper/ng-media-cropper.component';
import { ImageCropperViewComponent } from './components/image-cropper/image-cropper.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    PdfViewerModule,
    ImageCropperModule
  ],
  declarations: [
    NgMediaComponent,
    ImageCropperViewComponent,
    NgMediaCropperComponent,
    NgMediaFileExplorerComponent,
    UploadComponent,
    MediaToolbarComponent,
    GridViewComponent,
    MediaDetailsComponent,
    SpinnerComponent,
    NgdTranslatePipe
  ],
  entryComponents: [MediaDetailsComponent],
  providers: [
    UploaderService,
    HttpClient,
    DetailPanelService,
    UtilsService,
    StoreService,
    NgMediaConfigService,
    RequestsService
  ],
  exports: [
    NgMediaComponent,
    NgMediaFileExplorerComponent,
    NgMediaCropperComponent
  ]
})
export class NgMediaCoreModule {}
